import { useUserContext } from "components/providers/User";

const useSuperAdminCheck = () => {
  const { isSuperAdmin } = useUserContext();
  return isSuperAdmin;
};

export default useSuperAdminCheck;
